import { registerAction } from '../../Action'

const LOAD_LABEL_SETS = 'LOAD_LABEL_SETS'

const reducer = (state = {}, action) => ({
  ...state,
  label_sets: action.payload,
  label_sets_loaded: true,
})

const loadLabelSets = registerAction(LOAD_LABEL_SETS, { reducer })

export default loadLabelSets
